import { sendRequestWithAuth } from '../common/sendRequest';
import * as settings from './settings';

export function getProductFeatures(productName = null) {
  return sendRequestWithAuth(
    settings.ServerURL, {
      method: 'POST',
      body: JSON.stringify({
        operation: 'get_product_features',
        product_name: productName
      })
    }
  );
}

export function getFeatures() {
  return sendRequestWithAuth(
    settings.ServerURL, {
      method: 'POST',
      body: JSON.stringify({
        operation: 'get_features'
      })
    }
  );
}

export function getFeatureTypes() {
  return sendRequestWithAuth(
    settings.ServerURL, {
      method: 'POST',
      body: JSON.stringify({
        operation: 'get_feature_types'
      })
    }
  );
}


// WEBPACK FOOTER //
// ./src/services/features.js